"use strict";

var PropTypes = require('prop-types');

var React = require('react');

var compose = require('../../hoc/compose');

var displayNames = require('../displayNames');

var TooltipOnEllipsis = require('../tooltipOnEllipsis');

var getStyleFromProps = function getStyleFromProps(props) {
  return props.wasVisible ? props.wasVisibleStyle : {};
};

var DropDownOption = function DropDownOption(props) {
  return React.createElement('div', {
    className: props.getClassName('control-dropdown-option-content'),
    value: props.value,
    key: props.key || props.value,
    disabled: props.disabled,
    style: props.wasVisibleStyle ? getStyleFromProps(props) : null,
    'data-aid': props.automationId,
    'data-hook': props.dataHook
  }, props.children && (!props.isSelectedElement || props.forceChildren) ? props.children : React.createElement(TooltipOnEllipsis, {
    closeOnMouseClick: true
  }, props.translateIfNeeded(props.label) + (props.selectedValueSuffix ? props.selectedValueSuffix : '')));
};

DropDownOption.displayName = displayNames.DROP_DOWN_OPTION;
DropDownOption.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired]).isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  isSelectedElement: PropTypes.bool,
  wasVisible: PropTypes.bool,
  wasVisibleStyle: PropTypes.object,
  selectedValueSuffix: PropTypes.string,
  forceChildren: PropTypes.bool
};
DropDownOption.defaultProps = {
  disabled: false
};
module.exports = compose(DropDownOption);